<div #casinoAudioButton class="casino-immersive-lobby-audio-button">
    <audio #casinoAudio loop="true" [src]="audioUrl" [muted]="muted"></audio>
    <button
        class="casino-immersive-lobby-audio"
        aria-hidden="true"
        [class.theme-sound-loud]="!muted"
        [class.theme-sound-mute]="muted"
        (click)="onPlay()"></button>
</div>
